<template>
    <div class="saved-items-page">
        <div
            class="p-view_header p-view_header--tiles"
            data-qa="view_header"
        >
            <div class="p-view_header__text">
                <div class="p-view_header__big_button--inactive p-view_header__big_button--page p-view_header__big_button">
                    <div
                        class="p-view_header__title"
                        data-qa="channel_name"
                    >
                        <div class="p-ia__view_header__title">Saved items</div>
                        <div class="p-ia__view_header__spacer"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-workspace__primary_view_body">
            <div
                class="p-saved_page__item--education p-browse_page_education_card"
                role="group"
                aria-roledescription="notification"
                data-qa="saved_page-education-card"
                aria-label="Add messages and files to come back to later"
                v-if="show_info"
            >
                <div class="p-browse_page_education_card__content">
                    <h3 class="p-browse_page_education_card__title"><i
                            class="c-icon p-browse_page_education_card__title_icon p-saved_page__title_icon c-icon--bookmark c-icon--inline"
                            type="bookmark"
                            aria-hidden="true"
                        ></i>Add messages and files to come back to later</h3>
                    <div class="p-browse_page_education_card__body">Mark your to-dos or save something for another time. Only you can see your saved items, so use them however you’d like.</div>
                </div>
                <button
                    class="c-button-unstyled c-icon_button c-icon_button--light c-icon_button--size_medium p-browse_page_education_card__close"
                    data-qa="saved_page-education-card-close-button"
                    aria-label="Dismiss notification"
                    type="button"
                    @click="show_info = false"
                ><i
                        class="c-icon c-icon--times"
                        type="times"
                        aria-hidden="true"
                    ></i></button>
            </div>
        </div>
        <div
            class="item-container"
            :key="key"
            v-for="(item, key) in items"
        >
            <message-view
                :channel="item.channel"
                :message="item.message"
                @updated="update_item($event)"
            ></message-view>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { fetch_saved_items } from '../slack_api'
import MessageView from '../components/message/MessageView.vue'
export default {
    components: {
        MessageView,
    },
    computed: {
        ...mapGetters([
            'slack_is_signed_in',
        ]),
    },
    data() {
        return {
            items: [],
            show_info: true,
        }
    },
    methods: {
        update_item(message) {
            const idx = this.items.findIndex(i => i.message.ts === message.ts)
            if (idx !== -1) {
                this.items[idx].message = message
            }
        },
    },
    mounted() {
        fetch_saved_items({
            limit: 100,
        }).then(({ items, ok }) => {
            if (ok) {
                this.items = items
            }
        })
    },
    watch: {
    },
}
</script>
<style>
.saved-items-page .p-saved_page__item--education {
  margin: 20px;
  border-radius: 12px; }

.saved-items-page .p-browse_page_education_card {
  position: relative;
  box-sizing: border-box;
  padding: 20px 0 24px 24px;
  background-color: rgba(29, 28, 29, 0.04);
  border-radius: 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-width: 180px;
  flex-wrap: wrap; }
.saved-items-page .p-browse_page_education_card .p-browse_page_education_card__content {
  padding-right: 24px;
  flex: 1 1 0; }
.saved-items-page .p-browse_page_education_card .p-browse_page_education_card__content h3 {
  font-size: 18px;
  line-height: 1.33334;
  font-weight: 900; }
.saved-items-page .p-browse_page_education_card .p-browse_page_education_card__content .p-browse_page_education_card__title {
  margin-bottom: 12px;
  padding-right: 24px; }
.saved-items-page .p-browse_page_education_card .p-browse_page_education_card__content .p-browse_page_education_card__title .p-saved_page__title_icon {
  color: #e01e5a; }
.saved-items-page .p-browse_page_education_card .p-browse_page_education_card__content .p-browse_page_education_card__title .p-browse_page_education_card__title_icon {
  margin-right: 4px; }
.saved-items-page .p-browse_page_education_card .p-browse_page_education_card__content .p-browse_page_education_card__body {
  font-size: 15px;
  line-height: 1.46668;
  font-weight: 400; }
.saved-items-page .p-browse_page_education_card .p-browse_page_education_card__close {
  position: absolute;
  top: 12px;
  right: 12px; }

.saved-items-page .item-container {
  margin-bottom: 12px; }

</style>